var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 0.5,
    width: 40,
    height: 27,
    rx: 2,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0264 5.2373C31.9743 5.2373 35.9854 9.11043 35.9854 13.8877C35.9852 18.6648 31.9741 22.5371 27.0264 22.5371C24.8081 22.537 22.7794 21.7572 21.2148 20.4678C19.6503 21.7569 17.6223 22.5371 15.4043 22.5371C10.4565 22.5371 6.44552 18.6648 6.44531 13.8877C6.44531 9.11043 10.4564 5.2373 15.4043 5.2373C17.6223 5.23732 19.6503 6.01759 21.2148 7.30664C22.7794 6.01729 24.8082 5.23738 27.0264 5.2373Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0303 5.2373C31.978 5.23747 35.9893 9.11053 35.9893 13.8877C35.9891 18.6647 31.9779 22.5369 27.0303 22.5371C24.8121 22.5371 22.7834 21.7571 21.2188 20.4678C23.144 18.8813 24.3661 16.5231 24.3662 13.8877C24.3662 11.2521 23.1442 8.8932 21.2188 7.30664C22.7834 6.01741 24.8121 5.2373 27.0303 5.2373Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2178 7.30664C23.1434 8.8932 24.3652 11.252 24.3652 13.8877C24.3652 16.5232 23.1431 18.8812 21.2178 20.4678C19.2926 18.8812 18.0703 16.5231 18.0703 13.8877C18.0703 11.2521 19.2923 8.8932 21.2178 7.30664Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.cfd39126f36dac7301e0dbe4eae47123.svg";
export { ForwardRef as ReactComponent };